import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import i18n from "./i18n/config";
import App from "./App";

const RTL_LANGUAGES = ["he", "ar"];

const updateDirection = (lng: string) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = RTL_LANGUAGES.includes(lng) ? "rtl" : "ltr";
};

i18n.on("languageChanged", updateDirection);
updateDirection(i18n.language);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
